import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Combobox, ComboboxItem, Input } from '@node-space/ui-components'
import { AddBeneficiaryFormErrors, BaseFormProps } from 'types/beneficiaries'

interface NgnFormFieldsProps extends BaseFormProps {
  banks: ComboboxItem[]
  bankCode: string
  errors: AddBeneficiaryFormErrors
  fetchingBankList: boolean
  ngnAccountNumber: string
}

export const NgnFormFields = ({
  banks,
  bankCode,
  errors,
  ngnAccountNumber,
  fetchingBankList,
  handleChange,
  register,
}: NgnFormFieldsProps) => {
  const { t } = useTranslation()

  const handleBankOnChange = (bankCode: string) => {
    handleChange('bankCode', bankCode)
    const bankName = banks?.find(bank => bank?.value === bankCode)?.leftText
    if (bankName) {
      handleChange('bankName', bankName as string)
    }
  }

  return (
    <Box paddingB={16}>
      <Box flex gapX={12} paddingB={16}>
        <Input
          {...register('ngnAccountNumber')}
          label={t('accountNumber')}
          placeholder={t('enterAccountNumber')}
          inputMode="numeric"
          name="ngnAccountNumber"
          test-id="input-ngnAccountNumber"
          errorText={errors?.ngnAccountNumber?.message || errors?.accountNumber?.message}
          error={!!errors?.ngnAccountNumber || !!errors?.accountNumber}
          value={ngnAccountNumber}
          onChange={event => handleChange('ngnAccountNumber', event?.target?.value)}
        />
      </Box>

      <Combobox
        {...register('bankCode')}
        label={t('bank')}
        id="bank-code"
        selectPlaceholder={t('enterCode')}
        items={banks || []}
        onChange={value => handleBankOnChange(value)}
        errorText={errors?.bankCode?.message}
        defaultValue={bankCode}
        loading={fetchingBankList}
      />
    </Box>
  )
}
